import React, { useEffect, useState } from "react";
import { Form, Input, Checkbox, Button, Result } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import LoginTemplate from "../../../components/templates/LoginTemplate";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import { UserOutlined } from "@ant-design/icons";
import { linkProvider } from "../registrationSlice";
import { ReactComponent as Forgot } from "../../../assets/forgot-password.svg";
import { getCurrentTenant } from "../../../api/server";

const LinkProvider = () => {
  const [form] = Form.useForm();
  const intl = useIntl();
  const history = useHistory();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  const [tenant, setTenant] = useState({});
  const { invitationAccepted, error: registrationError } = useSelector(
    (state) => state.registration
  );
  const registrationInProgress = useSelector(
    (state) => state.registration.registrationInProgress
  );

  useEffect(() => {
    async function getTenantDetails() {
      const urlParams = new URLSearchParams(window.location.search);
      const tenantId = urlParams.get("tenantId");
      const tenantDetails = await getCurrentTenant();

      if (!tenantId) {
        setError("Wrong registration link");
      }
      setTenant(tenantDetails);
    }
    getTenantDetails();
  }, []);

  const onFinish = async (values) => {
    const params = {
      tenantId: tenant.name,
      authProvider: "microsoft.com",
      providerTenant: tenant.microsoft_auth_provider_tenant,
      email: values.email,
      href: window.location.href,
      history,
    };
    dispatch(linkProvider(params));
  };

  if (error || registrationError) {
    return (
      <Result
        status="warning"
        title={intl.formatMessage({
          id: "app.errors.failFetchInvitation",
        })}
        extra={
          <Button
            type="primary"
            key="console"
            onClick={() => {
              history.push("/");
            }}
          >
            {intl.formatMessage({
              id: "app.actions.goHome",
            })}
          </Button>
        }
      />
    );
  }

  if (!tenant.name) {
    return null; //show loading
  }

  if (invitationAccepted) {
    return <Redirect to="/" />;
  }

  return (
    <LoginTemplate
      title={intl.formatMessage({
        id: "app.forms.user.link_provider_title",
      })}
      subTitle={intl.formatMessage({
        id: "app.forms.user.link_provider_subtitle",
      })}
      image={<Forgot />}
    >
      <Form form={form} name="register" onFinish={onFinish} scrollToFirstError>
        <ChildrenAnimationWrapper>
          <AnimationChildWrapper itemKey={1}>
            <Form.Item name="email" hasFeedback>
              <Input
                prefix={<UserOutlined />}
                placeholder={intl.formatMessage({
                  id: "app.forms.user.email",
                })}
              />
            </Form.Item>
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={2}>
            <Form.Item
              name="agreement"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          intl.formatMessage({
                            id: "app.forms.user.should_accept_agreement",
                          })
                        ),
                },
              ]}
            >
              <Checkbox>
                <FormattedMessage id="app.forms.user.read_statement" />
                <a href="">
                  <FormattedMessage id="app.forms.user.terms" />
                </a>
              </Checkbox>
            </Form.Item>
          </AnimationChildWrapper>
          <AnimationChildWrapper itemKey={3}>
            <Form.Item>
              <Button
                block
                type="primary"
                htmlType="submit"
                loading={registrationInProgress}
              >
                <FormattedMessage id="app.forms.user.register" />
              </Button>
            </Form.Item>
          </AnimationChildWrapper>
        </ChildrenAnimationWrapper>
      </Form>
    </LoginTemplate>
  );
};

export default LinkProvider;
